<template>
  <div v-if="showComponent" :title="qaAble ? showIfHasPermission?.toString() : null" :key="componentRefresh">
    <div class="dropdown show">
      <button
        class="form-control dropdown-toggle"
        href=""
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :style="{ width: button_width, 'text-align': button_text_align }"
      >
        <label class="mr-2" v-if="title">
          <b>{{ title }}</b>
        </label>
        {{ optionsSelectedLabel }}
      </button>
      <ul
        class="dropdown-menu"
        id="multi-selector-drodown-menu"
        style="overflow-y: auto"
        :style="{ width: width, height: height, 'max-width': max_width, 'max-height': max_height }"
      >
        <li style="padding-right: 5px; padding-left: 5px; padding-bottom: 3px; font-size: 10px">
          <a href="" @click.prevent="selectAllOptions">Select all</a>
          |
          <a href="" @click.prevent="clearOptions">Clear</a>
        </li>
        <li style="padding-right: 5px; padding-left: 5px; padding-bottom: 8px; font-size: 12px" v-if="searchable">
          <div class="input-group">
            <input
              type="text"
              v-model="search"
              class="form-control form-control-sm rounded-right"
              placeholder="Search"
              aria-label="search"
              aria-describedby="search"
              autocomplete="new-password"
            />
            <span class="icon-inside"><i class="fa fa-search"></i></span>
          </div>
        </li>
        <template v-if="cacheOptions.length > 0">
          <li v-for="(option, index) in cacheOptions" :key="'option_container' + _uid + index" style="padding-right: 10px; padding-left: 10px">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                :id="'input_option_' + _uid + index"
                :value="option"
                v-model="checkedOptions"
                autocomplete="new-password"
              />
              <label :for="'input_option_' + _uid + index" class="form-check-label">
                <template v-if="!slotOptionLabel">
                  {{ option[label] ? option[label] : option }}
                </template>
                <slot name="optionLabel" :option="option"></slot>
              </label>
            </div>
          </li>
        </template>
        <template v-else>
          <li style="padding-right: 10px; padding-left: 10px">No Results found</li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
  import checkPermissions from '../../mixins/checkPermissions';

  export default {
    name: 'multi-selector-dropdown',
    mixins: [checkPermissions],
    props: {
      slotOptionLabel: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: null,
      },
      searchable: {
        type: Boolean,
        default: true,
      },
      value: {
        type: Array,
        default: () => [],
      },
      placeholder: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      options: {
        type: Array,
        required: true,
      },
      showLimit: {
        type: Number,
        default: 2,
      },
      width: {
        type: String,
        default: 'auto',
      },
      height: {
        type: String,
        default: 'auto',
      },
      max_width: {
        type: String,
        default: '350px',
      },
      max_height: {
        type: String,
        default: '350px',
      },
      button_width: {
        type: String,
        default: '100%',
      },
      button_text_align: {
        type: String,
        default: 'left',
      },
    },
    watch: {
      search: function (newVal, oldVal) {
        try {
          if (newVal.length > 0) {
            if (this.label) {
              this.cacheOptions = this.options.filter(o => o[this.label].toLowerCase().includes(newVal.toLowerCase()));
            } else {
              this.cacheOptions = this.options.filter(o => o.toLowerCase().includes(newVal.toLowerCase()));
            }
          } else {
            this.cacheOptions = JSON.parse(JSON.stringify(this.options));
          }
        } catch (err) {
          console.log('KS-APP: ', err);
        }
      },
      checkedOptions: {
        handler: function (val, oldVal) {
          this.$emit('input', val);
        },
        deep: true,
      },
      options: {
        handler: function (val, oldVal) {
          this.setCacheOptions(val);
        },
        deep: true,
      },
    },
    computed: {
      optionsSelectedLabel() {
        if (this.checkedOptions) {
          if (this.checkedOptions.length == 0) {
            return this.placeholder ? this.placeholder : 'None selected';
          } else {
            if (this.label) {
              if (this.checkedOptions.length > this.showLimit) {
                return `${this.checkedOptions.length} selected`;
              } else {
                return this.checkedOptions.map(e => (e[this.label] ? e[this.label] : '')).join(', ');
              }
            } else {
              return `${this.checkedOptions.length} selected`;
            }
          }
        } else {
          return this.placeholder ? this.placeholder : 'None selected';
        }
      },
      qaAble: {
        get: () => {
          return app.store.state.ks_app.global_data.qaAble;
        },
      },
    },
    mounted() {
      $('#multi-selector-drodown-menu').click(e => {
        e.stopPropagation();
      });
    },
    methods: {
      selectAllOptions() {
        this.checkedOptions = this.cacheOptions;
      },
      clearOptions() {
        this.checkedOptions = [];
      },
      setCacheOptions(options) {
        this.cacheOptions = JSON.parse(JSON.stringify(options));
        this.selectAllOptions();
      },
    },
    data() {
      return {
        checkedOptions: this.value,
        options_selected: '',
        cacheOptions: JSON.parse(JSON.stringify(this.options)),
        search: null,
      };
    },
  };
</script>
